import { TICKETS } from "@/data/tickets";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { TicketCard } from "@/components/cards/TicketCard";
import { ComparisonTable } from "@/components/blocks/ComparisonTable";
import { CTASection } from "@/components/common/CTASection";
import { AlertBox } from "@/components/common/AlertBox";
import { IMG } from "@/data/images";

export default function TicketsIndex() {
  const comparisonRows = TICKETS.map((t) => [
    t.shortName || t.name,
    `€${t.price}`,
    t.duration,
    t.badge || "—",
  ]);

  return (
    <>
      <PageHero
        overline="Tickets"
        title="Colosseum Tickets & Tours"
        subtitle="Compare every way to visit the Colosseum — from simple entry to underground tours — and book the experience that fits your trip."
        image={IMG.exteriorArena}
        breadcrumbs={[{ label: "Tickets" }]}
      />

      <section className="container-wide py-14 md:py-20">
        <SectionHeading
          overline="Choose your experience"
          title="Every Colosseum ticket, side by side"
          description="Nine carefully curated ticket types, each with transparent pricing and clear inclusions. Tap any card to explore the full details."
        />
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TICKETS.map((t, i) => (
            <Reveal key={t.slug} delay={(i % 3) * 0.08}>
              <TicketCard ticket={t} />
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-y border-stone-line bg-white/50">
        <div className="container-wide py-14 md:py-20">
          <SectionHeading
            overline="Quick comparison"
            title="Tickets at a glance"
            description="A fast overview to help you narrow down your choice before diving into the details."
          />
          <Reveal className="mt-8">
            <ComparisonTable
              columns={["Ticket", "From", "Duration", "Best known for"]}
              rows={comparisonRows}
            />
          </Reveal>
          <Reveal className="mt-8">
            <AlertBox
              tone="info"
              title="Not sure which to pick?"
              text="First-timers usually love a skip-the-line guided tour. History buffs should aim for the underground. Travelling with kids? A family ticket keeps everyone happy. Restricted-area tickets (underground & arena floor) sell out first, so book those early."
            />
          </Reveal>
        </div>
      </section>

      <div className="container-wide py-16 md:py-20">
        <CTASection />
      </div>
    </>
  );
}
